/* Validated public application. Versioned intake stores full answers and returns explicit customer-operation status. Pending account creation is retried with the same submission UUID. */
(function () {
  'use strict';
  function trk(event, data, opts) { if (window.stellar && window.stellar.track) return window.stellar.track(event, data, opts); }
  /* Public and signed-in applications use the same durable server workflow. */
  function label(name) { return String(name).replace(/^customer\[note\]\[|^customer\[|^contact\[|\]$/g, '').trim(); }
  function money(n, fmt) {
    var s = Math.round(n).toLocaleString('en-US');
    if (!fmt) return '$' + s;
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
  }

  /* the request card: the price follows the guests; the occasion tiles elsewhere on the page fill it in; then the steps */
  function request(root) {
    if (root.dataset.sxgOn) return; root.dataset.sxgOn = '1';
    var f = root.querySelector('form'); if (!f) return;
    var g = f.querySelector('[data-guests]'), total = f.querySelector('[data-total]'), per = parseFloat(root.getAttribute('data-price') || '150'), fmt = root.getAttribute('data-money') || '', unit = root.getAttribute('data-guests-word') || 'guests';
    var min = parseInt(g && g.min || '2', 10) || 2, max = parseInt(g && g.max || '400', 10) || 400;
    function price() {
      if (!g) return;
      var n = Math.max(min, Math.min(max, parseInt(g.value || '0', 10) || min)); g.value = n;
      if (total) total.innerHTML = money(n * per, fmt) + '<small>' + n + ' ' + unit + '</small>';
      var hid = f.querySelector('[data-expected]'); if (hid) hid.value = money(n * per, fmt);
    }
    var minus = f.querySelector('[data-minus]'), plus = f.querySelector('[data-plus]');
    if (minus) minus.addEventListener('click', function () { g.value = (parseInt(g.value, 10) || min) - 1; price(); });
    if (plus) plus.addEventListener('click', function () { g.value = (parseInt(g.value, 10) || min) + 1; price(); });
    if (g) g.addEventListener('input', price);
    price();
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pick]'); if (!a) return;
      var r = f.querySelector('input[name="customer[note][Occasion]"][value="' + a.dataset.pick.replace(/"/g, '\\"') + '"]'); if (r) r.checked = true;
      if (a.dataset.pickGuests && g) { g.value = a.dataset.pickGuests; price(); }
      trk('occasion_picked', { occasion: a.dataset.pick }, { el: a });
    });
    var steps = Array.prototype.slice.call(f.querySelectorAll('.step')), last = steps.length, i = 0;
    var nav = f.querySelector('[data-nav]'), back = f.querySelector('[data-back]'), next = f.querySelector('[data-next2]'), submit = f.querySelector('[data-submit]'), bar = f.querySelector('.bar i'), first = f.querySelector('[data-next]');
    var advanceTimer = null;
    function cancelAdvance() {
      if (advanceTimer !== null) { clearTimeout(advanceTimer); advanceTimer = null; }
    }
    function queueAdvance(input) {
      cancelAdvance();
      var expected = i, step = steps[i];
      if (!step || !step.contains(input) || i >= last - 1) return;
      advanceTimer = setTimeout(function () {
        advanceTimer = null;
        if (i === expected && steps[i] === step && !step.hidden && input.checked && valid()) show(expected + 1);
      }, 260);
    }
    function show(n) { cancelAdvance();
      i = Math.max(0, Math.min(n, last - 1)); steps.forEach(function (st, k) { st.hidden = k !== i; });
      if (nav) nav.hidden = i === 0;
      var lastQ = i === last - 1;
      if (back) back.hidden = false; if (next) next.hidden = lastQ; if (submit) submit.hidden = !lastQ;
      if (bar) bar.style.width = Math.round(((i + 1) / last) * 100) + '%';
      if (i === 1) { var own = f.querySelector('input[name="customer[note][Venue]"][value="A place of our own"]'), opt = f.querySelector('[data-own]'); if (own && own.checked && opt) opt.checked = true; }
      var el = steps[i].querySelector('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea'); if (el && i > 0) setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }, 350);
      trk('form_step_viewed', { form: f.id || 'request', step: i + 1, of: last, question: (steps[i].querySelector('.q') || steps[i].querySelector('.stepno') || {}).textContent || '' }, { el: f });
    }
    function valid(){return window.stellar.formAdapters.validate(steps[i]);}
    if (first) first.addEventListener('click', function () { if (valid()) { trk('request_started', { form: f.id || 'request' }, { el: f }); show(1); } });
    if (next) next.addEventListener('click', function () { if (valid()) show(i + 1); });
    if (back) back.addEventListener('click', function () { show(i - 1); });
    f.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      trk('form_answered', { form: f.id || 'request', step: i + 1, question: label(e.target.name), answer: e.target.value }, { el: f });
      if (i > 0 && i < last - 1 && e.target.closest('.opts')) queueAdvance(e.target);
    });
    var adapter=window.stellar.formAdapters;
    var intakeId=f.id==='event-add'?'event_creation_request':'savor_experience_request';
    adapter.bind({form:f,button:submit,formId:intakeId,
      isFinalStep:function(){return i===last-1;},nextStep:function(){if(valid())show(i+1);},
      validate:function(){for(var k=0;k<last;k++){show(k);if(!valid())return false;}return true;},
      payload:function(){
        
        var p=adapter.fromForm(f,intakeId,{includeHidden:true,purpose:f.id==='event-add'?'operational':'lead'});
        delete p.fields.body;delete p.field_labels.body;
        return p;
      },
      isComplete:function(receipt){return intakeId==='event_creation_request'||adapter.applicationComplete(receipt);},
      onAccepted:async function(receipt){
        if(intakeId==='event_creation_request')adapter.showSaved(f,'Thank you — your request has been received.');
        else adapter.applicationReceipt(f,submit,receipt);
      }
    });
    show(root.querySelector('.errors') ? last - 1 : 0);
  }

  /* the request: file the labelled fields in the warehouse and Klaviyo before the page posts to Shopify.
     The form may carry a password, so the data layer's own form capture leaves it alone; this is the one place it is recorded. */

  function beats(bx) {
    if (bx.dataset.sxgOn) return; bx.dataset.sxgOn = '1';
    var btns = bx.querySelectorAll('[data-beat]'), films = bx.querySelectorAll('[data-beat-film]'), k = bx.querySelector('[data-beat-k]'), t = bx.querySelector('[data-beat-text]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.beat;
        btns.forEach(function (x) { x.classList.toggle('on', x === b); });
        films.forEach(function (fm) { fm.classList.toggle('on', +fm.dataset.beatFilm === i); });
        if (k) k.textContent = b.getAttribute('data-kicker') || ''; if (t) t.textContent = b.getAttribute('data-text') || '';
        trk('beat_viewed', { beat: b.textContent.trim() }, { el: b });
      });
    });
  }

  /* the rings: one word lit at a time, moving on its own until you touch it */
  function ring(r, k) {
    if (r.dataset.sxgOn) return; r.dataset.sxgOn = '1';
    var ws = r.querySelectorAll('span'), i = k % (ws.length || 1), t;
    if (!ws.length) return;
    function lit() { ws.forEach(function (w, j) { w.classList.toggle('on', j === i); }); }
    function tick() { i = (i + 1) % ws.length; lit(); }
    lit(); t = setInterval(tick, 2200);
    r.addEventListener('mouseenter', function () { clearInterval(t); ws.forEach(function (w) { w.classList.remove('on'); }); });
    r.addEventListener('mouseleave', function () { t = setInterval(tick, 2200); });
  }

  /* the room: sub-nav follows the chapter in view; copy buttons */
  function subnav(nav) {
    if (nav.dataset.sxgOn || !('IntersectionObserver' in window)) return; nav.dataset.sxgOn = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!en.isIntersecting) return; links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + en.target.id); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
  }
  function copied(b) { var was = b.textContent; b.textContent = b.getAttribute('data-copied') || 'Copied'; setTimeout(function () { b.textContent = was; }, 1400); }
  function copyBtn(b) {
    if (b.dataset.sxgOn) return; b.dataset.sxgOn = '1';
    b.addEventListener('click', function () {
      var t = b.getAttribute('data-copy'); if (!t) { var src = b.closest('[data-copy-root]'), el = src && src.querySelector('[data-copy-text]'); t = el ? el.textContent : ''; }
      try { navigator.clipboard.writeText(String(t).trim()); } catch (e) {}
      copied(b); trk('copied', { what: b.getAttribute('data-track-label') || 'text' }, { el: b });
    });
  }
  function share(b) {
    if (b.dataset.sxgOn) return; b.dataset.sxgOn = '1';
    b.addEventListener('click', function (e) {
      var d = { title: b.getAttribute('data-share-title') || document.title, text: b.getAttribute('data-share-text') || '', url: b.getAttribute('data-share-url') || location.href };
      if (navigator.share) { e.preventDefault(); navigator.share(d).catch(function () {}); trk('shared', { url: d.url }, { el: b }); }
    });
  }

  function init(root) {
    if (root.matches('[data-request]')) request(root); else root.querySelectorAll('[data-request]').forEach(request);
    root.querySelectorAll('[data-beats]').forEach(beats);
    root.querySelectorAll('[data-ring]').forEach(ring);
    root.querySelectorAll('[data-subnav]').forEach(subnav);
    root.querySelectorAll('[data-copy],[data-copy-from]').forEach(copyBtn);
    root.querySelectorAll('[data-share]').forEach(share);
  }
  function boot() { document.querySelectorAll('[data-sxg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sxg]').forEach(init); });
})();
